<div class="mt-3 mr-2 ml-1">
  <p>
    Bạn có muốn xóa <span class="font-bold">{{ description }}</span> ?
  </p>
</div>
<div *nzModalFooter>
  <div>
    <button nz-button (click)="no()">Đóng</button>
    <button nz-button nzType="danger" (click)="yes()">Xóa</button>
  </div>
</div>
